import React, { useMemo } from "react";
import { Eye, EyeOff } from "lucide-react";
import { processColors } from "./constants";

const ProcessLegend = ({ templates, isVisible, onToggle }) => {
  // Collect unique processes from all templates
  const uniqueProcesses = useMemo(() => {
    const processMap = new Map();
    templates.forEach((template) => {
      if (template.processes) {
        template.processes.forEach((process) => {
          if (!processMap.has(process.id)) {
            processMap.set(process.id, {
              id: process.id,
              label: process.label,
              color: processColors[process.id] || processColors[1],
            });
          }
        });
      }
    });
    return Array.from(processMap.values());
  }, [templates]);

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-semibold text-gray-900">Prozesslegende</h3>
        <button
          onClick={onToggle}
          className="p-1 hover:bg-gray-100 rounded transition-colors"
        >
          {isVisible ? (
            <EyeOff className="w-4 h-4 text-gray-500" />
          ) : (
            <Eye className="w-4 h-4 text-gray-500" />
          )}
        </button>
      </div>

      {isVisible && (
        <div className="space-y-2 max-h-[400px] overflow-y-auto">
          {uniqueProcesses.map((process) => (
            <div
              key={process.id}
              className="flex items-center gap-2 p-2 hover:bg-gray-50 rounded"
            >
              <div
                className="w-3 h-3 rounded-full flex-shrink-0"
                style={{ backgroundColor: process.color }}
              />
              <span className="text-sm text-gray-700 truncate">
                {process.label}
              </span>
            </div>
          ))}
          {uniqueProcesses.length === 0 && (
            <p className="text-sm text-gray-400 text-center py-4">
              Keine Prozesse vorhanden
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default ProcessLegend;
